import { c as _c } from "react/compiler-runtime";
import { Typography, type TypographyProps } from '@mui/material';
import classNames from 'classnames';
import { Link, type GeneralLinkProps } from './link';
const typographyVariants: Record<'link' | 'tinyLink' | 'fileName', TypographyProps['variant']> = {
  link: 'subtitle1',
  tinyLink: 'subtitle2',
  fileName: 'fileName'
};
export const TextLink = t0 => {
  const $ = _c(11);
  let props;
  let t1;
  let typographyVariant;
  if ($[0] !== t0) {
    const {
      className,
      typographyVariant: t2,
      ...t3
    } = t0;
    typographyVariant = t2;
    props = t3;
    t1 = classNames("underline", {
      "text-(--mui-palette-text-disabled)": props.disabled,
      "text-(--mui-palette-text-primary) hover:text-(--mui-palette-text-secondary)": !props.disabled
    }, className);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = typographyVariant;
  } else {
    props = $[1];
    t1 = $[2];
    typographyVariant = $[3];
  }
  const linkClassName = t1;
  if (!typographyVariant) {
    let t2;
    if ($[4] !== linkClassName || $[5] !== props) {
      t2 = <Link {...props} className={linkClassName}>{props.children}</Link>;
      $[4] = linkClassName;
      $[5] = props;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  const t2 = typographyVariants[typographyVariant];
  let t3;
  if ($[7] !== linkClassName || $[8] !== props || $[9] !== t2) {
    t3 = <Typography {...props} component={Link} variant={t2} className={linkClassName}>{props.children}</Typography>;
    $[7] = linkClassName;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};